import { render, staticRenderFns } from "./bannerSchool.vue?vue&type=template&id=418525d0"
import script from "./bannerSchool.vue?vue&type=script&lang=js"
export * from "./bannerSchool.vue?vue&type=script&lang=js"
import style0 from "./bannerSchool.vue?vue&type=style&index=0&id=418525d0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('418525d0')) {
      api.createRecord('418525d0', component.options)
    } else {
      api.reload('418525d0', component.options)
    }
    module.hot.accept("./bannerSchool.vue?vue&type=template&id=418525d0", function () {
      api.rerender('418525d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bannerSchool.vue"
export default component.exports